import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {
        idPadre: 0,
        codigo: "",
        descripcion: "",
        estado: "",
    },
    listPadre: [],
    results: [],
}

export const catalogSearchSlice = createSlice({
    name: "catalogSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
        setListPadre: (state, action) => {
            state.listPadre = action.payload;
        },
    },
});

export const { setValue, setResults, setListPadre } = catalogSearchSlice.actions;
export default catalogSearchSlice.reducer;